import HttpClient from './http-client';
import URL from './url';

export default class HomeworkApi {

    static createHomework(payload) {
        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK, null, payload);
    }

    static createHomeworkForClickerPractice(payload) {
        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK_FOR_CLICKER_PRACTICE, null, payload);
    }

    static createAdaptiveHomework(payload) {
        return HttpClient.post(URL.BASE_URL + URL.ADAPTIVE_HOMEWORK, null, payload);
    }

    static createHomeworkForLink(payload) {
        return HttpClient.post(URL.BASE_URL + URL.CREATE_HOMEWORK_FOR_LINK, null, payload);
    }

    static homeworkQuestionCategory(payload) {
        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK_QUESTION_CATEGORY, null, payload);
    }



    static homeworkReminder(payload) {
        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK_REMINDER, null, payload);
    }

    static homeworkDeeplink(payload) {
        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK_DEEP_LINK, null, payload);
    }

    static getHomework(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK + "?" + params.join('&') : URL.HOMEWORK;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkCompletionReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_COMPLETION_REPORT + "?" + params.join('&') : URL.HOMEWORK_COMPLETION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkSchoolDetails(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_SCHOOL_DETAILS + "?" + params.join('&') : URL.HOMEWORK_SCHOOL_DETAILS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static downloadHomeworkReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_DOWNLOAD_REPORT + "?" + params.join('&') : URL.HOMEWORK_DOWNLOAD_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkEvaluationReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_EVALUATION_REPORT + "?" + params.join('&') : URL.HOMEWORK_EVALUATION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getLevelProgressionReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_LEVEL_PROGRESSION_REPORT + "?" + params.join('&') : URL.HOMEWORK_LEVEL_PROGRESSION_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStudentDetailReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_STUDENT_DETAIL_REPORT + "?" + params.join('&') : URL.HOMEWORK_STUDENT_DETAIL_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkWrongAnswersReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_WRONG_ANSWERS_REPORT + "?" + params.join('&') : URL.HOMEWORK_WRONG_ANSWERS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkAllQuetionsReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_ALL_QUESTIONS_REPORT + "?" + params.join('&') : URL.HOMEWORK_ALL_QUESTIONS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static updateHomework(payload) {
        return HttpClient.put(URL.BASE_URL + URL.HOMEWORK, null, payload);
    }

    static getHomeworkDetail(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_DETAIL + "?" + params.join('&') : URL.HOMEWORK_DETAIL;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getChapterHierarchy(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CHAPTER_HIERARCHY + "?" + params.join('&') : URL.CHAPTER_HIERARCHY;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getChapterHierarchyWithFilters(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CHAPTER_HIERARCHY_SEARCH + "?" + params.join('&') : URL.CHAPTER_HIERARCHY_SEARCH;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkEloDetails(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_ELO_DETAILS + "?" + params.join('&') : URL.HOMEWORK_ELO_DETAILS;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkEloDetailsForClickerPractice(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_ELO_DETAILS_FOR_CLICKER_PRACTICE + "?" + params.join('&') : URL.HOMEWORK_ELO_DETAILS_FOR_CLICKER_PRACTICE;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkStatusWrongAnswersReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_STATUS_WRONG_ANSWERS_REPORT + "?" + params.join('&') : URL.HOMEWORK_STATUS_WRONG_ANSWERS_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getEloReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_ELO_REPORT + "?" + params.join('&') : URL.HOMEWORK_ELO_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStudentListForEloReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_ELO_REPORT_STUDENT_LIST + "?" + params.join('&') : URL.HOMEWORK_ELO_REPORT_STUDENT_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkDetailForLink(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_DETAIL_FOR_LINK + "?" + params.join('&') : URL.HOMEWORK_DETAIL_FOR_LINK;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }


    static assignHomework(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ASSIGN_HOMEWORK + "?" + params.join('&') : URL.ASSIGN_HOMEWORK;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }



    static assignHomeworkV2(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ASSIGN_HOMEWORK_V2 + "?" + params.join('&') : URL.ASSIGN_HOMEWORK_V2;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static assignHomeworkV3(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.ASSIGN_HOMEWORK_V3 + "?" + params.join('&') : URL.ASSIGN_HOMEWORK_V3;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static sendHomeworkNotification(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.SEND_HOMEWORK_NOTIFICATION + "?" + params.join('&') : URL.SEND_HOMEWORK_NOTIFICATION;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }


    static getTeacherHomeworkActivities(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.TEACHER_HOMEWORK_ACTIVITY + "?" + params.join('&') : URL.TEACHER_HOMEWORK_ACTIVITY;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getHomeworkAssessmentContents(payload) {

        return HttpClient.post(URL.BASE_URL + URL.HOMEWORK_ASSESSMENT_CONTENTS, null, payload);
    }

    static downloadOfflineUserAssessmentActivity(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.DOWNLOAD_OFFLINE_USER_ASSESSMENT_ACTIVITY + "?" + params.join('&') : URL.DOWNLOAD_OFFLINE_USER_ASSESSMENT_ACTIVITY;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static syncOfflineUserAssessmentActivity(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SYNC_OFFLINE_USER_ASSESSMENT_ACTIVITY, null, payload);
    }

    static downloadQuestionWisePercentageReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.DOWNLOAD_QUESIONWISE_PERCENTAGE_REPORT + "?" + params.join('&') : URL.DOWNLOAD_QUESIONWISE_PERCENTAGE_REPORT;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStandardCompetencyReportForClassSpecificPractice(payload) {

        let url = URL.BASE_URL + URL.CLASS_SPECIFIC_PRACTICE_REPORT_PDF;

        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }

        if (params && params.length) {
            url = url + "?" + params.join('&');
        }

        return HttpClient.get(url, payload);
    }

    static getStudentClassSpecificPracticeReportPDF(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENT_CLASS_SPECIFIC_PRACTICE_REPORT_PDF + "?" + params.join('&') : URL.STUDENT_CLASS_SPECIFIC_PRACTICE_REPORT_PDF;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static syncOfflineUserClickerPracticeActivity(payload) {
        return HttpClient.post(URL.BASE_URL + URL.SYNC_OFFLINE_USER_CLICKER_PRACTICE_ACTIVITY, null, payload);
    }

    static getStudentHomeworkReport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENT_HOMEWORK_REPORT + "?" + params.join('&') : URL.STUDENT_HOMEWORK_REPORT;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }


    static getChapterQuestionTypeSetInfo(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_CHAPTER_QUESTION_TYPE_SET_INFO + "?" + params.join('&') : URL.HOMEWORK_CHAPTER_QUESTION_TYPE_SET_INFO;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getHomeworksForMasterSchoolwork(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_HOMEWORK_FOR_MASTER_SCHOOLWORK + "?" + params.join('&') : URL.GET_HOMEWORK_FOR_MASTER_SCHOOLWORK;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getHomeworkCompletionReportForMasterHomework(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_HOMEWORK_COMPLETED_LIST_FOR_MASTER_HOMEWORK + "?" + params.join('&') : URL.GET_HOMEWORK_COMPLETED_LIST_FOR_MASTER_HOMEWORK;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getCustomHomeworksForExport(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.GET_MASTER_HOMEWORK_EXPORT + "?" + params.join('&') : URL.GET_MASTER_HOMEWORK_EXPORT;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }

    static getHomeworkCompletedStudentSummary(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_COMPLETED_STUDENT_SUMMARY + "?" + params.join('&') : URL.HOMEWORK_COMPLETED_STUDENT_SUMMARY;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }
    
    static getHomeworkCompletedStudent(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.HOMEWORK_COMPLETED_STUDENT_LIST + "?" + params.join('&') : URL.HOMEWORK_COMPLETED_STUDENT_LIST;
        return HttpClient.get(URL.BASE_URL + paramsList, payload);
    }
    



}